<template>
  <div class="about">
    <Header active="about"></Header>
      <el-row class="banner" type="flex" align="middle">
          <el-col :span="2"></el-col>
          <el-col :span="4">
              <span class="business-title">关于我们</span>
          </el-col>
      </el-row>
      <el-row class="spacing-up">
          <h1>公司简介</h1>
      </el-row>
      <el-row>
          <div class="business-content">
              <div class="corner"></div>
              <el-row style="width: 100%;" >
                  <el-row class="company-img" :gutter="50">
                      <el-col :span="8">
                          <img src="../../assets/imgs/about/company1.jpg"/>
                      </el-col>
                      <el-col :span="8">
                          <img src="../../assets/imgs/about/company2.jpg"/>
                      </el-col>
                      <el-col :span="8">
                          <img src="../../assets/imgs/about/company3.jpg"/>
                      </el-col>
                  </el-row>
                  <el-row class="business-text">
                    <p>
                        长春市三合通科技有限责任公司是由净月高新区政府牵头、联合行业头部企业科大讯飞和北京百分点及专业人士共同出资组建的混合所有制高科技公司，总部位于长春市净月开发区净月影视文化创意产业园5号楼A区6层。
                    </p>
                    <p>
                        基于“符合客户要求、契合技术趋势、联合产业资源”的经营理念，公司先后与长春市政府、农安县政府、松原市政府、白山市政府、吉林大学、山东理工大学、长春光机所、东北地理所、吉林农大、吉林省农科院、中国移动、中国联通、东北证券、吉林西部产业园、联适导航、广州大气候、蓝湖科技等建立了业务合作关系，开展智慧农业、智能装备以及智慧城市相关业务。
                    </p>
                    <p>
                        围绕主营业务，公司形成了系列自主产品解决方案，包括智慧农业整体解决方案（智慧农业综合管理云服务平台）、智能农机装备整体解决方案（智能行走装备监控服务系统）、智慧旅游解决方案（全域旅游云服务-数据仓库分析系统）、智能环保装备等产品应用解决方案，获得相关软件著作权49项和专利权4项，现已通过国家高新技术企业、吉林省“专精特新”中小企业及软件企业认证。
                    </p>
                    <p>
                        公司在农业全过程无人作业试验区建设领域同车载信息服务产业应用联盟（TIAA）紧密合作，全面参与并推动了农业全过程无人作业的技术开发、标准制定、示范应用和试验区建设等多方面的工作；具体负责东北地区农业全过程无人作业试验示范区的技术指导和业务实施工作。牵头制定了玉米全过程无人作业工程实施路线图。
                    </p>
                    <p>
                        在生态无人农场建设领域与山东理工大学生态无人农场研究院共同开发了生态无人农场云端大脑产品，并于2020年11月与农安县人民政府共同启动了新安合作区生态无人农场示范基地项目，成为国内第二家和示范面积全国最大的生态无人农场；目前该产品已在农安县玉米大田、山东沂源果园等多家农场得到了应用。
                    </p>
                    <p>
                        在智能环保装备领域自主研发了生物质热解处理器以及无动力粪污（有机垃圾）离子矿化处理器，现已纳入吉林省千万头肉牛建设工程——畜禽粪污处理试点应用产品。
                    </p>
                    <p>
                        面向未来，三合通科技以“为客户创造价值、为员工创造幸福、为社会创造财富”为使命，发扬勇于挑战，敢于创造的企业精神，立足长春、迈向全国、走向世界。
                    </p>
                  </el-row>
              </el-row>
          </div>
      </el-row>


      <el-row class="spacing-up">
      </el-row>
      <el-row>
          <div class="about-speech">
              <el-row :gutter="50">
                  <el-col :span="7">
                      <el-row>
                          <img src="../../assets/imgs/about/leader.png" class="leader-img" />
<!--                          <el-row>-->
<!--                              <el-col :span="4" style="height: 10px;">-->
<!--                              </el-col>-->
<!--                              <el-col :span="6">-->
<!--                                  <p class="leader-name">董事长：</p>-->
<!--                              </el-col>-->
<!--                              <el-col :span="6">-->
<!--                                  <img src="../../assets/imgs/about/leader-sign.jpg" style="width: 150px; height: auto;">-->
<!--                              </el-col>-->
<!--                              <el-col :span="6" style="height: 10px;">-->
<!--                              </el-col>-->
<!--                          </el-row>-->
                      </el-row>
                  </el-col>
                  <el-col :span="17" class="about-text-right">
                      <h1 class="speach-title">董事长致辞</h1>
                      <el-row>
                          <p>
                              感谢每一位关心、关注三合通科技的朋友和伙伴，三合通科技在长春市、净月开发区政府、社会各界及各位伙伴的支持下于2020年4月29日正式成立了，这是个充满朝气和活力的新生命体，是奋斗者、实干家、挑战者和创造者用智慧谱写美好人生的舞台，三合通科技倡导“天和、人和、心和”下的生态协同；倡导员工自主管理，笃信人心齐泰山移；立志成为知名的智慧产业应用专家；实现“立足长春、迈向全国、走向世界”的梦想。
                          </p>
                          <p>
                              “勇于挑战、敢于创造’‘是我们的企业精神，我们坚信只要勇于挑战，就会把不可能变成可能；只要敢于创造，梦想就会变成现实；只要坚定了这样的信念，未来就一定属于我们！
                          </p>
                          <p>
                              “智会三合，通达四海“，为践行‘’为客户创造价值、为员工创造幸福、为社会创造财富“的使命，让我们共同携手、共创共享，共生共赢，共同谱写人生绚丽篇章！
                          </p>
                      </el-row>
                  </el-col>
              </el-row>
          </div>
      </el-row>


      <el-row class="spacing-up">
          <h1>愿景与文化</h1>
      </el-row>

      <el-row class="about-target">
          <el-row class="about-culture">

              <el-row class="about-culture-bottom">
                  <el-row class="about-culture-title">公司愿景</el-row>
                  <el-row class="about-culture-text">成为知名的智慧产业应用专家</el-row>
                  <el-row class="about-empty"></el-row>
              </el-row>

              <el-row class="about-culture-bottom">
                  <el-row class="about-culture-title">五年目标（2025）</el-row>
                  <el-row class="about-culture-text">在国内智慧产业应用领域崭露头角；核心骨干持股、打造高科技上市公司；员工收入达到同行业高等水平</el-row>
                  <el-row class="about-empty"></el-row>
              </el-row>

              <el-row class="about-culture-bottom">
                  <el-row class="about-culture-title">十五年目标（2035）</el-row>
                  <el-row class="about-culture-text">企业实现百千万工程：百亿级收入、千亿级市值、万人规模</el-row>
                  <el-row class="about-culture-text">员工实现十百千工程：十个千万富翁、百个百万年薪收入、千个幸福家庭</el-row>
                  <el-row class="about-empty"></el-row>
              </el-row>


          </el-row>
      </el-row>

      <el-row class="culture-bg">
          <el-row style="width: 84%; height: 700px; background-color: rgba(255,255,255,0.5); margin: 0 auto;">
              <el-row class="about-culture">

                  <el-row class="about-culture-item">
                      <el-row class="about-culture-title">公司使命</el-row>
                      <el-row class="about-culture-text">为客户创造价值、为员工创造幸福、为社会创造财富</el-row>
                      <el-row class="about-empty"></el-row>
                  </el-row>

                  <el-row class="about-culture-item">
                      <el-row class="about-culture-title">企业精神</el-row>
                      <el-row class="about-culture-text">勇于挑战、敢于创造</el-row>
                      <el-row class="about-empty"></el-row>
                  </el-row>

                  <el-row class="about-culture-item">
                      <el-row class="about-culture-title">经营理念</el-row>
                      <el-row class="about-culture-text">符合客户要求、契合技术趋势、联合产业资源</el-row>
                      <el-row class="about-empty"></el-row>
                  </el-row>

                  <el-row class="about-culture-item">
                      <el-row class="about-culture-title">核心价值观</el-row>
                      <el-row class="about-culture-text">坚持、创新、奋斗、分享</el-row>
                      <el-row class="about-empty"></el-row>
                  </el-row>

                  <el-row class="about-culture-item">
                      <el-row class="about-culture-title">干事原则</el-row>
                      <el-row class="about-culture-text">认真干事、激情干事、快乐干事、健康干事</el-row>
                      <el-row class="about-empty"></el-row>
                  </el-row>

                  <el-row class="about-culture-item">
                      <el-row class="about-culture-title">人才观</el-row>
                      <el-row class="about-culture-text">想干事、能干事、干实事、干成事，就是人才</el-row>
                      <el-row class="about-empty"></el-row>
                  </el-row>

              </el-row>
          </el-row>

      </el-row>


      <el-row>
          <!-- <el-row class="spacing-up">
              <h1>生态伙伴</h1>
          </el-row> -->
          <img src="../../assets/imgs/home/partner/partner.png" style="width: 88%; height: auto;">
      </el-row>

        <el-row style="padding: 0 50px;">
          <el-row class="spacing-up">
              <h1>科技创新与知识产权</h1>
          </el-row>
         <el-row class="spacing-up">
             <el-col :span="6" v-for="item in piclist1" v-bind:key="item">
                 <div >
                    <div><img style="width:80%" :src="item.url" /></div>
                    <div style="margin-top: 20px"><span style="font-size: 15px;font-weight:bold">{{item.title}}</span></div>
                 </div>
            </el-col>
          </el-row>
          <el-row class="spacing-up">
             <el-col :span="6" v-for="item in piclist2" v-bind:key="item">
                 <div >
                    <div><img style="width:80%" :src="item.url" /></div>
                    <div style="margin-top: 20px"><span style="font-size: 15px;font-weight:bold">{{item.title}}</span></div>
                 </div>
            </el-col>
          </el-row>
          <el-row class="spacing-up">
             <el-col :span="6" v-for="item in piclist3" v-bind:key="item">
                 <div >
                    <div><img style="width:80%" :src="item.url" /></div>
                    <div style="margin-top: 20px"><span style="font-size: 15px;font-weight:bold">{{item.title}}</span></div>
                 </div>
            </el-col>
          </el-row>
      </el-row>


      <Footer></Footer>
  </div>
</template>
<script>
    import Header from '../../components/Header.vue'
    import Footer from '../../components/Footer.vue'

    export default {
        name: 'PCAbout',
        components: {Header, Footer},
  data () {
    return {
     piclist1: [{
      id: 0,
        type: 'image',
        url: 'https://www.ccsht.cn/resources/static/images/intell/zhnyzhglyfwpt.png',
        title:'智慧农业综合管理云服务平台'
    }, {
      id: 1,
      type: 'image',
      url: 'https://www.ccsht.cn/resources/static/images/intell/znxzzbjkfwxt.png',
      title:'智能行走装备监控服务系统',
    },{
      id: 2,
      type: 'image',
      url: 'https://www.ccsht.cn/resources/static/images/intell/nywlwjcxt.png',
      title:'农业物联网监测系统'
    },{
      id: 3,
      type: 'image',
      url: 'https://www.ccsht.cn/resources/static/images/intell/yyynjdzyhjkzdsbdcxrj.png',
      title:'应用于农机的作业和监控终端设备的程序软件'
    },
    ],
    piclist2: [ {
      id: 0,
      type: 'image',
      url: 'https://www.ccsht.cn/resources/static/images/intell/IOT-Cloudzdjrwgfwxt.png',
      title:'IOT-Cloud终端接入网关服务系统'
    }, {
      id: 1,
      type: 'image',
      url: 'https://www.ccsht.cn/resources/static/images/intell/qylyyfw-sjckfxxt.png',
      title:'全域旅游云服务-数据仓库分析系统'
    }, {
      id: 2,
      type: 'image',
      url: 'https://www.ccsht.cn/resources/static/images/intell/5Ajlyhyglxt.png',
      title:'5A级旅游会员管理系统'
    },{
      id: 3,
      type: 'image',
      url: 'https://www.ccsht.cn/resources/static/images/intell/lyyqjkglxt.png',
      title:'旅游园区监控管理系统'
    }
    ],
    piclist3: [{
      id: 0,
      type: 'image',
      url: 'https://www.ccsht.cn/resources/static/images/intell/qyly-htyycljkxt.png',
      title:'全域旅游-环潭运营车辆监控系统'
    },{
      id: 1,
      type: 'image',
      url: 'https://www.ccsht.cn/resources/static/images/intell/lyspsjglxt.png',
      title:'旅游售票数据管理系统'
    },{
      id: 2,
      type: 'image',
      url: 'https://www.ccsht.cn/resources/static/images/intell/yzwdlfwlzkhclqdqytqzz.png',
      title:'一种粪污无动力离子矿化处理器的气压透气装置'
    },{
      id: 3,
      type: 'image',
      url: 'https://www.ccsht.cn/resources/static/images/intell/yzshfwcldrjqhzz.png',
      title:'一种适合粪污处理的热解气化装置'
    }
    ],
    }
  },
    }
</script>
<style scoped>
    .about {
        height: 100%;
        width: 100%;
    }
    .banner {
        height: 300px;
        width: 100%;
        background: url("../../assets/imgs/about/about_bg.jpg") no-repeat;
        background-size: 100% 100%;
    }
    .business-title {
        font-size: 36px;
        color: #ffffff;
        margin-top: 100px;
    }

    .business-content {
        width: 100%;
        /*height: 500px;*/
        background: #f2f2f2;
        background-size: 100% 100%;
    }

    .business-text {
        font-size: 18px;
        text-align: left;
        /*padding-left: 60px;*/
        line-height: 36px;
        color: #505050;
        padding: 0 8%;
        margin: 60px 0;
    }

    .about-text-right {
        font-size: 18px;
        text-align: left;
        /*padding-right: 60px;*/
        line-height: 36px;
        color: #505050;
    }

    .about-text-right p {
        text-indent: 2em;
    }

    .business-text p {
        text-indent: 2em;
    }

    .business-img {
        width: 500px;
        height: auto;
    }

    .corner {
        width: 0;
        height: 0;
        border-left: 25px solid transparent;
        border-right: 25px solid transparent;
        border-top: 25px solid #ffffff;
        z-index: 100;
        position: relative;
        margin: 0 auto;
    }

    .about-speech {
        /*width: 100%;*/
        /*height: 500px;*/
        padding: 0 8%;
    }

    .leader-img {
        /*height: 400px;*/
        /*width: 350px;*/
        width: 100%;
        height: auto;
    }
    .leader-name {
        font-size: 18px;
        display: inline-block;
    }
    .about-culture {
        text-align: left;
        padding: 0 10%;
    }
    .about-culture-title {
        color: #ff4e00;
        font-size: 30px;
    }
    .about-culture-text {
        font-size: 20px;
    }

    .about-culture-bottom {
        margin-bottom: 30px;
    }

    .about-culture-item {
        border-bottom: 1px solid #505050;
        margin-bottom: 30px;
    }
    .about-empty {
        height: 20px;
        width: 100%;
    }

    .culture-bg {
        width: 100%; height: 800px;
        background: url("../../assets/imgs/about/item-bg.jpg") no-repeat bottom;
        background-size: 100% 50%;
    }

    .partner-container {
        width: 100%;
        height: 400px;
        background-size: 100% 100%;
    }


    .parter-row {
        height: 30%;
        width: 100%;
    }

    .partner-item {
    }

    .parter-item img {
        height: 60px;
        width: 180px;
    }

    .parter-text {
        font-size: 24px;
    }

    .spacing-up {
        margin-top: 30px;
        margin-bottom: 20px;
    }

    .company-img {
        padding: 0 8%;
        margin-top: 60px;
    }

    .company-img img {
        width: 100%;
        height: auto;
    }
    .about-target {
        width: 84%; background-color: #f5f8fc; margin: 0 auto;
    }
    .about-target .about-culture {
        margin-top: 50px;
    }

    .speach-title {
        text-align: center;
        margin-block-start: 0;
    }
</style>
